import { atom } from "jotai";

export const evaluacionesFiltradasAtom = atom([]);
export const loadingAtom = atom(false)
